import { FunctionComponent } from 'react';

// Icons are sourced from https://heroicons.dev

export type IconProps = {
  className?: string;
};

export const HomeIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
      />
    </svg>
  );
};

export const CalendarIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  );
};

export const ExtLinkIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
      />
    </svg>
  );
};

export const TaskListIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
      />
    </svg>
  );
};

export const SettingsIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
};

export const LocationIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
};

export const LocationIconFilled: FunctionComponent<IconProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9393 4.86021C21.2197 8.14061 21.2197 13.4592 17.9393 16.7396L11.9996 22.6793L6.05991 16.7396C2.77951 13.4592 2.77951 8.14061 6.05991 4.86021C9.34032 1.5798 14.6589 1.5798 17.9393 4.86021ZM11.9996 13.1999C13.3251 13.1999 14.3996 12.1254 14.3996 10.7999C14.3996 9.47442 13.3251 8.3999 11.9996 8.3999C10.6741 8.3999 9.59961 9.47442 9.59961 10.7999C9.59961 12.1254 10.6741 13.1999 11.9996 13.1999Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const OfficeIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
      />
    </svg>
  );
};

export const GovernmentIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Registration Icon</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
      />
    </svg>
  );
};

export const TaxIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
      />
    </svg>
  );
};

export const InsuranceIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
      />
    </svg>
  );
};

export const RegistrationIcon: FunctionComponent<IconProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
      />
    </svg>
  );
};

export const HumanResourcesIcon: FunctionComponent<IconProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>HR Icon</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
  );
};

export const PayrollIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
  );
};

export const MoreIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
      />
    </svg>
  );
};

export const ExpandIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </svg>
  );
};

export const EditIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </svg>
  );
};

export const ActionIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13 10V3L4 14h7v7l9-11h-7z"
      />
    </svg>
  );
};

export const AddPersonIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 21 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
      />
    </svg>
  );
};

export const LoadingIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 50 50"
    >
      <title>Loading icon</title>
      <path
        fill="currentColor"
        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
};

export const LinkIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3274 3.1274C10.4934 2.95548 10.692 2.81835 10.9116 2.72402C11.1313 2.62968 11.3674 2.58003 11.6065 2.57795C11.8455 2.57587 12.0825 2.62142 12.3037 2.71192C12.5249 2.80243 12.7259 2.93608 12.8949 3.10509C13.0639 3.2741 13.1975 3.47507 13.2881 3.69628C13.3786 3.9175 13.4241 4.15452 13.422 4.39352C13.4199 4.63253 13.3703 4.86872 13.276 5.08833C13.1816 5.30794 13.0445 5.50656 12.8726 5.6726L10.1726 8.3726C9.83502 8.71005 9.37727 8.89962 8.89997 8.89962C8.42268 8.89962 7.96492 8.71005 7.62738 8.3726C7.45763 8.20866 7.23029 8.11794 6.99431 8.11999C6.75834 8.12204 6.53261 8.2167 6.36574 8.38356C6.19887 8.55043 6.10422 8.77616 6.10217 9.01214C6.10012 9.24812 6.19083 9.47546 6.35477 9.6452C7.02987 10.3201 7.94538 10.6992 8.89997 10.6992C9.85457 10.6992 10.7701 10.3201 11.4452 9.6452L14.1452 6.9452C14.8009 6.26623 15.1638 5.35686 15.1556 4.41296C15.1474 3.46905 14.7688 2.56612 14.1013 1.89865C13.4339 1.23118 12.5309 0.852577 11.587 0.844374C10.6431 0.836172 9.73374 1.19903 9.05477 1.8548L7.70477 3.2048C7.61882 3.28782 7.55025 3.38713 7.50308 3.49694C7.45592 3.60674 7.43109 3.72484 7.43005 3.84434C7.42901 3.96384 7.45178 4.08235 7.49704 4.19296C7.54229 4.30357 7.60912 4.40405 7.69362 4.48856C7.77812 4.57306 7.87861 4.63989 7.98922 4.68514C8.09982 4.73039 8.21833 4.75317 8.33784 4.75213C8.45734 4.75109 8.57543 4.72626 8.68524 4.67909C8.79504 4.63192 8.89435 4.56336 8.97738 4.4774L10.3274 3.1274ZM5.82737 7.6274C6.16492 7.28995 6.62268 7.10039 7.09997 7.10039C7.57727 7.10039 8.03502 7.28995 8.37257 7.6274C8.4556 7.71336 8.55491 7.78192 8.66471 7.82909C8.77451 7.87626 8.89261 7.90109 9.01211 7.90213C9.13161 7.90316 9.25013 7.88039 9.36073 7.83514C9.47134 7.78989 9.57183 7.72306 9.65633 7.63856C9.74083 7.55405 9.80766 7.45357 9.85291 7.34296C9.89817 7.23235 9.92094 7.11384 9.9199 6.99434C9.91886 6.87484 9.89403 6.75674 9.84687 6.64694C9.7997 6.53713 9.73113 6.43782 9.64517 6.3548C8.97007 5.6799 8.05457 5.30077 7.09997 5.30077C6.14538 5.30077 5.22987 5.6799 4.55477 6.3548L1.85477 9.0548C1.51094 9.38689 1.23668 9.78413 1.04801 10.2233C0.859337 10.6626 0.760027 11.135 0.755873 11.613C0.751719 12.091 0.842806 12.565 1.02382 13.0074C1.20483 13.4499 1.47214 13.8518 1.81015 14.1898C2.14817 14.5278 2.55011 14.7951 2.99254 14.9762C3.43497 15.1572 3.90901 15.2483 4.38702 15.2441C4.86502 15.2399 5.33742 15.1406 5.77663 14.952C6.21585 14.7633 6.61309 14.489 6.94517 14.1452L8.29517 12.7952C8.38113 12.7122 8.4497 12.6129 8.49687 12.5031C8.54403 12.3933 8.56886 12.2752 8.5699 12.1557C8.57094 12.0362 8.54817 11.9176 8.50291 11.807C8.45766 11.6964 8.39083 11.5959 8.30633 11.5114C8.22183 11.4269 8.12134 11.3601 8.01073 11.3149C7.90013 11.2696 7.78161 11.2468 7.66211 11.2479C7.54261 11.2489 7.42451 11.2737 7.31471 11.3209C7.20491 11.3681 7.1056 11.4366 7.02257 11.5226L5.67257 12.8726C5.50653 13.0445 5.30791 13.1816 5.0883 13.276C4.8687 13.3703 4.6325 13.42 4.3935 13.4221C4.15449 13.4241 3.91747 13.3786 3.69626 13.2881C3.47504 13.1976 3.27407 13.0639 3.10506 12.8949C2.93606 12.7259 2.8024 12.5249 2.7119 12.3037C2.62139 12.0825 2.57585 11.8455 2.57792 11.6065C2.58 11.3675 2.62966 11.1313 2.72399 10.9117C2.81833 10.6921 2.95546 10.4934 3.12737 10.3274L5.82737 7.6274Z"
        fill="#787986"
      />
    </svg>
  );
};

export const EmailIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  );
};

export const FaxIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
      />
    </svg>
  );
};

export const MailIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.8225 3.62844C0.570806 3.78935 0.363258 4.0131 0.219374 4.27864C0.0754905 4.54419 -7.00019e-07 4.8428 0 5.1464V12.2099C0 12.6847 0.184374 13.14 0.512563 13.4757C0.840752 13.8114 1.28587 14 1.75 14H12.25C12.7141 14 13.1592 13.8114 13.4874 13.4757C13.8156 13.14 14 12.6847 14 12.2099V5.1464C14 4.8428 13.9245 4.54419 13.7806 4.27864C13.6367 4.0131 13.4292 3.78935 13.1775 3.62844L7.9275 0.272092C7.64937 0.0942814 7.32799 0 7 0C6.67201 0 6.35063 0.0942814 6.0725 0.272092L0.8225 3.62844ZM3.11062 5.79709C3.01502 5.73185 2.9078 5.68652 2.79507 5.66368C2.68234 5.64083 2.56631 5.64092 2.45362 5.66395C2.34092 5.68697 2.23376 5.73247 2.13826 5.79785C2.04275 5.86323 1.96077 5.94722 1.897 6.04501C1.83323 6.1428 1.78891 6.25248 1.76657 6.36779C1.74424 6.4831 1.74433 6.60178 1.76684 6.71706C1.81229 6.94986 1.9463 7.15467 2.13938 7.28641L6.51437 10.2695C6.65816 10.3677 6.82715 10.42 7 10.42C7.17285 10.42 7.34184 10.3677 7.48563 10.2695L11.8606 7.28641C12.0537 7.15467 12.1877 6.94986 12.2332 6.71706C12.2786 6.48425 12.2318 6.24251 12.103 6.04501C11.9742 5.84751 11.774 5.71044 11.5464 5.66395C11.3188 5.61745 11.0825 5.66534 10.8894 5.79709L7 8.44905L3.11062 5.79709Z"
        fill="#787986"
      />
    </svg>
  );
};

export const PhoneIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H3.153C3.38971 0.000108969 3.6187 0.0841807 3.79924 0.23726C3.97979 0.390339 4.10018 0.602499 4.139 0.836L4.879 5.271C4.91436 5.48222 4.88097 5.69921 4.78376 5.89003C4.68655 6.08085 4.53065 6.23543 4.339 6.331L2.791 7.104C3.34611 8.47965 4.17283 9.72928 5.22178 10.7782C6.27072 11.8272 7.52035 12.6539 8.896 13.209L9.67 11.661C9.76552 11.4695 9.91994 11.3138 10.1106 11.2166C10.3012 11.1194 10.5179 11.0859 10.729 11.121L15.164 11.861C15.3975 11.8998 15.6097 12.0202 15.7627 12.2008C15.9158 12.3813 15.9999 12.6103 16 12.847V15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16H13C5.82 16 0 10.18 0 3V1Z"
        fill="#787986"
      />
    </svg>
  );
};

export const LeftIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 16l-4-4m0 0l4-4m-4 4h18"
      />
    </svg>
  );
};

export const RightIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 8l4 4m0 0l-4 4m4-4H3"
      />
    </svg>
  );
};

export const SortAscIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
      />
    </svg>
  );
};

export const SortDescIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
      />
    </svg>
  );
};

export const ErrorIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    </svg>
  );
};

export const OpenDownIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 9l-7 7-7-7"
      />
    </svg>
  );
};

export const CollapseLeftIcon: FunctionComponent<IconProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 19l-7-7 7-7"
      />
    </svg>
  );
};

export const ExpandRightIcon: FunctionComponent<IconProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 5l7 7-7 7"
      />
    </svg>
  );
};

export const SupportIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
  );
};

export const SelectIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 9l4-4 4 4m0 6l-4 4-4-4"
      />
    </svg>
  );
};

export const CheckIcon: FunctionComponent<
  IconProps & { strokeWidth?: number }
> = ({ className, strokeWidth = 2 }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Check Icon</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M5 13l4 4L19 7"
      />
    </svg>
  );
};

export const SearchIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      />
    </svg>
  );
};

export const ArrowRightIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M14 5l7 7m0 0l-7 7m7-7H3"
      />
    </svg>
  );
};

export const ArrowLeftIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 19l-7-7m0 0l7-7m-7 7h18"
      />
    </svg>
  );
};

export const RecurIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
      />
    </svg>
  );
};

export const MinusIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20 12H4"
      />
    </svg>
  );
};

export const LockIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      />
    </svg>
  );
};

export const LightBulbIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
      />
    </svg>
  );
};

export const CloseIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
};

export const FastForwardIcon: FunctionComponent<IconProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M11.933 12.8a1 1 0 000-1.6L6.6 7.2A1 1 0 005 8v8a1 1 0 001.6.8l5.333-4zM19.933 12.8a1 1 0 000-1.6l-5.333-4A1 1 0 0013 8v8a1 1 0 001.6.8l5.333-4z"
      />
    </svg>
  );
};

export const DownloadIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Download Icon</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
      />
    </svg>
  );
};

export const PDFIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>PDF Icon</title>
      <g clipPath="url(#clip0_1486_23129)">
        <path
          d="M8.45012 12.3201C8.35012 12.3201 8.12012 12.2701 8.12012 12.4901V16.4901C8.12209 16.5283 8.13318 16.5655 8.15246 16.5986C8.17174 16.6317 8.19865 16.6596 8.23095 16.6802C8.26325 16.7007 8.29999 16.7133 8.33812 16.7167C8.37625 16.7202 8.41465 16.7145 8.45012 16.7001C8.87943 16.516 9.24448 16.2088 9.49905 15.8171C9.75361 15.4255 9.88623 14.9671 9.88012 14.5001C9.87843 14.0373 9.7424 13.5849 9.48855 13.1979C9.2347 12.8109 8.87396 12.506 8.45012 12.3201Z"
          fill="#950000"
        />
        <path
          d="M4.00012 12.12H3.38012C3.31116 12.12 3.24503 12.1474 3.19627 12.1961C3.14751 12.2449 3.12012 12.311 3.12012 12.38V13.62C3.1227 13.6872 3.15123 13.7508 3.19972 13.7974C3.2482 13.844 3.31286 13.87 3.38012 13.87H4.00012C4.12288 13.8831 4.24704 13.8703 4.36451 13.8323C4.48199 13.7943 4.59016 13.7321 4.682 13.6495C4.77383 13.567 4.84727 13.4661 4.89754 13.3533C4.94781 13.2405 4.97379 13.1185 4.97379 12.995C4.97379 12.8715 4.94781 12.7494 4.89754 12.6367C4.84727 12.5239 4.77383 12.423 4.682 12.3405C4.59016 12.2579 4.48199 12.1957 4.36451 12.1577C4.24704 12.1197 4.12288 12.1068 4.00012 12.12Z"
          fill="#950000"
        />
        <path
          d="M18 19V10C18 9.73478 17.8946 9.48043 17.7071 9.29289C17.5196 9.10536 17.2652 9 17 9H1C0.734784 9 0.48043 9.10536 0.292893 9.29289C0.105357 9.48043 0 9.73478 0 10L0 19C0 19.2652 0.105357 19.5196 0.292893 19.7071C0.48043 19.8946 0.734784 20 1 20H17C17.2652 20 17.5196 19.8946 17.7071 19.7071C17.8946 19.5196 18 19.2652 18 19ZM4 15.12H3.38C3.31104 15.12 3.24491 15.1474 3.19615 15.1962C3.14739 15.2449 3.12 15.311 3.12 15.38V17.5C3.12 17.6644 3.05468 17.8221 2.93841 17.9384C2.82213 18.0547 2.66443 18.12 2.5 18.12C2.33557 18.12 2.17787 18.0547 2.06159 17.9384C1.94532 17.8221 1.88 17.6644 1.88 17.5V11.5C1.87998 11.3346 1.94498 11.1759 2.06097 11.058C2.17697 10.9402 2.33465 10.8726 2.5 10.87H4C4.53839 10.907 5.04269 11.1469 5.41099 11.5413C5.77929 11.9358 5.98414 12.4553 5.98414 12.995C5.98414 13.5347 5.77929 14.0542 5.41099 14.4487C5.04269 14.8431 4.53839 15.083 4 15.12ZM7.5 18.12C7.33557 18.12 7.17787 18.0547 7.06159 17.9384C6.94532 17.8221 6.88 17.6644 6.88 17.5V11.5C6.87998 11.3346 6.94498 11.1759 7.06097 11.058C7.17697 10.9402 7.33465 10.8726 7.5 10.87C8.42848 10.9188 9.30285 11.322 9.94281 11.9964C10.5828 12.6709 10.9395 13.5652 10.9395 14.495C10.9395 15.4248 10.5828 16.3191 9.94281 16.9936C9.30285 17.668 8.42848 18.0712 7.5 18.12ZM15.5 12.12H13.5C13.3992 12.12 13.3026 12.16 13.2313 12.2313C13.16 12.3026 13.12 12.3992 13.12 12.5V13.62C13.1226 13.6872 13.1511 13.7508 13.1996 13.7974C13.2481 13.844 13.3127 13.87 13.38 13.87H14.5C14.6522 13.8893 14.792 13.9634 14.8934 14.0785C14.9948 14.1935 15.0508 14.3416 15.0508 14.495C15.0508 14.6484 14.9948 14.7965 14.8934 14.9115C14.792 15.0266 14.6522 15.1007 14.5 15.12H13.38C13.311 15.12 13.2449 15.1474 13.1962 15.1962C13.1474 15.2449 13.12 15.311 13.12 15.38V17.5C13.12 17.6644 13.0547 17.8221 12.9384 17.9384C12.8221 18.0547 12.6644 18.12 12.5 18.12C12.3356 18.12 12.1779 18.0547 12.0616 17.9384C11.9453 17.8221 11.88 17.6644 11.88 17.5V12.5C11.8787 12.2864 11.9196 12.0747 12.0004 11.877C12.0813 11.6793 12.2004 11.4995 12.3509 11.348C12.5015 11.1965 12.6805 11.0763 12.8777 10.9943C13.0749 10.9122 13.2864 10.87 13.5 10.87H15.5C15.6522 10.8893 15.792 10.9634 15.8934 11.0785C15.9948 11.1935 16.0508 11.3416 16.0508 11.495C16.0508 11.6484 15.9948 11.7965 15.8934 11.9115C15.792 12.0266 15.6522 12.1007 15.5 12.12Z"
          fill="#950000"
        />
        <path
          d="M23.71 5.71L18.29 0.29C18.1037 0.105256 17.8523 0.00110462 17.59 0L6 0C5.46957 0 4.96086 0.210714 4.58579 0.585786C4.21071 0.960859 4 1.46957 4 2V7.75C4 7.8163 4.02634 7.87989 4.07322 7.92678C4.12011 7.97366 4.1837 8 4.25 8H5.75C5.8163 8 5.87989 7.97366 5.92678 7.92678C5.97366 7.87989 6 7.8163 6 7.75V2.5C6 2.36739 6.05268 2.24021 6.14645 2.14645C6.24021 2.05268 6.36739 2 6.5 2H16.75C16.8163 2 16.8799 2.02634 16.9268 2.07322C16.9737 2.12011 17 2.1837 17 2.25V5C17 5.53043 17.2107 6.03914 17.5858 6.41421C17.9609 6.78929 18.4696 7 19 7H21.75C21.8163 7 21.8799 7.02634 21.9268 7.07322C21.9737 7.12011 22 7.1837 22 7.25V21.5C22 21.6326 21.9473 21.7598 21.8536 21.8536C21.7598 21.9473 21.6326 22 21.5 22H6.25C6.1837 22 6.12011 21.9737 6.07322 21.9268C6.02634 21.8799 6 21.8163 6 21.75V21.25C6 21.1837 5.97366 21.1201 5.92678 21.0732C5.87989 21.0263 5.8163 21 5.75 21H4.25C4.1837 21 4.12011 21.0263 4.07322 21.0732C4.02634 21.1201 4 21.1837 4 21.25V22C4 22.5304 4.21071 23.0391 4.58579 23.4142C4.96086 23.7893 5.46957 24 6 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V6.41C23.9989 6.14766 23.8947 5.89626 23.71 5.71Z"
          fill="#6B7280"
        />
      </g>
      <defs>
        <clipPath id="clip0_1486_23129">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PrintIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Print Icon</title>
      <path
        fill="currentColor"
        d="M7 10C6.80222 10 6.60888 10.0586 6.44443 10.1685C6.27998 10.2784 6.15181 10.4346 6.07612 10.6173C6.00043 10.8 5.98063 11.0011 6.01921 11.1951C6.0578 11.3891 6.15304 11.5673 6.29289 11.7071C6.43275 11.847 6.61093 11.9422 6.80491 11.9808C6.99889 12.0194 7.19996 11.9996 7.38268 11.9239C7.56541 11.8482 7.72159 11.72 7.83147 11.5556C7.94135 11.3911 8 11.1978 8 11C8 10.7348 7.89464 10.4804 7.70711 10.2929C7.51957 10.1054 7.26522 10 7 10ZM19 6H18V3C18 2.73478 17.8946 2.48043 17.7071 2.29289C17.5196 2.10536 17.2652 2 17 2H7C6.73478 2 6.48043 2.10536 6.29289 2.29289C6.10536 2.48043 6 2.73478 6 3V6H5C4.20435 6 3.44129 6.31607 2.87868 6.87868C2.31607 7.44129 2 8.20435 2 9V15C2 15.7956 2.31607 16.5587 2.87868 17.1213C3.44129 17.6839 4.20435 18 5 18H6V21C6 21.2652 6.10536 21.5196 6.29289 21.7071C6.48043 21.8946 6.73478 22 7 22H17C17.2652 22 17.5196 21.8946 17.7071 21.7071C17.8946 21.5196 18 21.2652 18 21V18H19C19.7956 18 20.5587 17.6839 21.1213 17.1213C21.6839 16.5587 22 15.7956 22 15V9C22 8.20435 21.6839 7.44129 21.1213 6.87868C20.5587 6.31607 19.7956 6 19 6ZM8 4H16V6H8V4ZM16 20H8V16H16V20ZM20 15C20 15.2652 19.8946 15.5196 19.7071 15.7071C19.5196 15.8946 19.2652 16 19 16H18V15C18 14.7348 17.8946 14.4804 17.7071 14.2929C17.5196 14.1054 17.2652 14 17 14H7C6.73478 14 6.48043 14.1054 6.29289 14.2929C6.10536 14.4804 6 14.7348 6 15V16H5C4.73478 16 4.48043 15.8946 4.29289 15.7071C4.10536 15.5196 4 15.2652 4 15V9C4 8.73478 4.10536 8.48043 4.29289 8.29289C4.48043 8.10536 4.73478 8 5 8H19C19.2652 8 19.5196 8.10536 19.7071 8.29289C19.8946 8.48043 20 8.73478 20 9V15Z"
      />
    </svg>
  );
};

export const UserIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
      />
    </svg>
  );
};

export const SparkleIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
      />
    </svg>
  );
};

export const MessageIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2
      0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  );
};

export const RefreshIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
      />
    </svg>
  );
};

export const ComparisonIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 118 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect
          x="0.261719"
          y="74"
          width="74"
          height="74"
          rx="37"
          transform="rotate(-90 0.261719 74)"
          fill="#CAEAEA"
          fillOpacity="0.31"
        />
      </g>
      <g>
        <rect
          x="43.7383"
          y="73.9995"
          width="74"
          height="74"
          rx="37"
          transform="rotate(-90 43.7383 73.9995)"
          fill="#CAEAEA"
          fillOpacity="0.31"
        />
      </g>
    </svg>
  );
};

export const PlusIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      />
    </svg>
  );
};

export const CheckCircleIcon: FunctionComponent<IconProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
};

export const LogoIcon: FunctionComponent<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      stroke="currentColor"
      viewBox="0 0 315.81 77.16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Logo</title>
      <path d="M85.71,25.2V59.39c0,.51-.41,.92-.92,.92h-17.19c-.51,0-.92-.41-.92-.92V26.11c0-2.14-.12-4.59-1.02-6.57-.41-.84-.96-1.54-1.62-2.05-1.08-.84-2.47-1.25-4.25-1.25-3.32,0-5.89,1.14-6.7,2.98-.93,1.99-.93,4.71-.93,6.9V59.39c0,.51-.41,.92-.92,.92h-16.73c-.51,0-.92-.41-.92-.92l-.04-33.28c0-2.14-.12-4.59-1.02-6.57-.41-.84-.96-1.54-1.62-2.05-1.08-.84-2.47-1.25-4.25-1.25-3.32,0-5.89,1.14-6.7,2.98-.93,1.99-.93,4.71-.93,6.9V59.39c0,.51-.41,.92-.92,.92H.92c-.51,0-.92-.41-.92-.92V.92C0,.41,.41,0,.92,0H17.03c.51,0,.92,.41,.92,.92V3.39c0,.37,.41,.59,.72,.38,12.98-8.93,25.62,.98,25.75,1.09,.46,.36,.9,.75,1.3,1.14,.35,.35,.68,.7,1,1.04,.38,.42,1.04,.4,1.4-.04,.96-1.18,2.16-2.29,3.52-3.26,1.76-1.26,3.67-2.18,5.51-2.69,10.87-3.71,20.31,3.73,20.41,3.8,.46,.36,.9,.75,1.3,1.14h0c5.88,5.91,6.87,10.7,6.87,19.19Z" />
      <path d="M150.25,30.18c0,16.64-13.73,30.18-30.6,30.18s-30.6-13.54-30.6-30.18S102.78,0,119.65,0s30.6,13.54,30.6,30.18Zm-17.26,0c0-7.25-5.98-13.16-13.34-13.16s-13.34,5.9-13.34,13.16,5.98,13.16,13.34,13.16,13.34-5.9,13.34-13.16Z" />
      <path d="M197.38,41.99c-.15,2.05-.67,4.22-1.57,6.48-3.5,7.45-11.59,11.89-21.65,11.89-1.39,0-2.82-.09-4.25-.25-4.53-.53-8.49-1.74-11.77-3.58-3.38-2.29-5.95-5.48-7.69-9.51-.24-.54,.08-1.17,.66-1.29l16.03-3.45c.37-.08,.76,.08,.97,.39,1.12,1.68,3.03,2.49,4.07,2.62,2.45,.29,3.72-.36,4.36-.97,.64-.61,.94-1.44,.82-2.34-.25-2.03-1.47-2.97-7.67-5.93l-.08-.04c-1.23-.59-2.77-1.32-4.49-2.17-1.18-.51-2.34-1.07-3.41-1.64l-.09-.05c-.15-.09-.3-.18-.47-.27-5.56-3.19-8.81-7.07-9.65-11.54-1.19-6.39,2.91-11.81,3.75-12.83,1.24-1.4,2.69-2.63,4.3-3.66,4.86-3.1,11.14-4.39,17.67-3.62,3.91,.46,7.46,1.51,10.55,3.13,1.47,.77,2.83,1.68,4.05,2.71,.84,.74,3.46,3.34,4.27,7.31,.1,.5-.23,.99-.73,1.1l-15.78,3.19c-.45,.09-.88-.16-1.05-.58-.44-1.1-1.41-2.2-3.5-2.45-1.38-.16-2.63,.25-3.43,1.13-.6,.67-.86,1.5-.66,2.19,.3,1.05,1.38,2.72,7.27,5.11,1.17,.46,2.24,.87,3.32,1.31,1.37,.49,2.7,1.02,3.94,1.57h0c3.75,1.75,12.41,6.82,11.9,16.06Z" />
      <path d="M315.75,1.23l-19.06,51.33-8.45,23.98c-.13,.37-.48,.61-.87,.61h-17.9c-.63,0-1.07-.62-.87-1.21l7.01-20.78c.07-.2,.06-.41,0-.61L255.5,1.24c-.22-.6,.22-1.24,.87-1.24h16.04c.39,0,.73,.24,.87,.6l11.44,29.31c.3,.81,1.45,.8,1.73-.02L297.05,.62c.13-.37,.48-.62,.87-.62h16.96c.64,0,1.08,.63,.87,1.23Z" />
      <path d="M257.36,42.82c-4.86,10.34-15.48,17.53-27.78,17.53-16.87,0-30.6-13.54-30.6-30.17S212.71,0,229.58,0s30.6,13.54,30.6,30.17c0,1.83-.17,3.62-.48,5.36-.08,.44-.47,.77-.92,.77h-40.36c-.72,0-1.16,.78-.79,1.4,2.48,4.21,6.92,6.82,11.83,6.82,4.17,0,8.06-1.84,10.83-5.38,.21-.27,.55-.41,.89-.35l15.46,2.78c.6,.11,.97,.76,.71,1.31m-15.19-20.35c-.72-4.25-5.63-7.56-11.88-7.56-5.68,0-11.07,3.29-11.87,7.54-.11,.57,.33,1.09,.91,1.09h21.93c.57,0,1.01-.52,.91-1.08Z" />
    </svg>
  );
};

export const CircleAddIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11V8C11 7.44772 11.4477 7 12 7Z"
      fill="currentColor"
    />
  </svg>
);

export const TrashIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66699 7.33333V11.3333M9.33366 7.33333V11.3333M2.66699 4.66667H13.3337M12.667 4.66667L12.089 12.7613C12.065 13.0977 11.9145 13.4125 11.6677 13.6424C11.4209 13.8722 11.0962 14 10.759 14H5.24166C4.90442 14 4.5797 13.8722 4.33292 13.6424C4.08613 13.4125 3.9356 13.0977 3.91166 12.7613L3.33366 4.66667H12.667ZM10.0003 4.66667V2.66667C10.0003 2.48986 9.93009 2.32029 9.80506 2.19526C9.68004 2.07024 9.51047 2 9.33366 2H6.66699C6.49018 2 6.32061 2.07024 6.19559 2.19526C6.07056 2.32029 6.00033 2.48986 6.00033 2.66667V4.66667H10.0003Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilledLockIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const EyeIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.45703 12C3.73103 7.943 7.52203 5 11.999 5C16.477 5 20.267 7.943 21.541 12C20.267 16.057 16.477 19 11.999 19C7.52203 19 3.73103 16.057 2.45703 12Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const EyeOffIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.70711 3.29289C4.31658 2.90237 3.68342 2.90237 3.29289 3.29289C2.90237 3.68342 2.90237 4.31658 3.29289 4.70711L5.71706 7.13127C4.28639 8.20737 3.03925 9.68543 2.10557 11.5528C1.96481 11.8343 1.96481 12.1657 2.10557 12.4472C4.26379 16.7637 8.09687 19 12 19C13.5552 19 15.0992 18.645 16.5306 17.9448L19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L4.70711 3.29289ZM15.0138 16.428C14.0343 16.8112 13.0134 17 12 17C9.03121 17 5.99806 15.3792 4.12966 12C4.94721 10.5214 5.98778 9.3794 7.14838 8.56259L9.29237 10.7066C9.10495 11.0982 9 11.5369 9 12C9 13.6569 10.3431 15 12 15C12.4631 15 12.9018 14.8951 13.2934 14.7076L15.0138 16.428Z"
      fill="currentColor"
    />
    <path
      d="M18.5523 13.8955C19.0353 13.3402 19.4784 12.7088 19.8703 12C18.0019 8.62078 14.9687 7 12 7C11.888 7 11.7759 7.00231 11.6637 7.00693L9.87939 5.22258C10.5774 5.07451 11.2875 5 12 5C15.9031 5 19.7362 7.23635 21.8944 11.5528C22.0352 11.8343 22.0352 12.1657 21.8944 12.4472C21.3504 13.5352 20.7 14.491 19.9689 15.3121L18.5523 13.8955Z"
      fill="currentColor"
    />
  </svg>
);

export const CopyIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V16H4C2.89543 16 2 15.1046 2 14V4ZM10 16V20H20V10H16V14C16 15.1046 15.1046 16 14 16H10ZM14 14V4L4 4V14H14Z"
      fill="currentColor"
    />
  </svg>
);

export const FingerPrintIcon: FunctionComponent<IconProps> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 11C11.9999 14.5172 10.9911 17.7988 9.24707 20.5712M5.80688 18.5304C5.82459 18.5005 5.84273 18.4709 5.8613 18.4413C7.2158 16.2881 7.99991 13.7418 7.99991 11C7.99991 8.79086 9.79077 7 11.9999 7C14.209 7 15.9999 8.79086 15.9999 11C15.9999 12.017 15.9307 13.0186 15.7966 14M13.6792 20.8436C14.2909 19.6226 14.7924 18.3369 15.1707 17M19.0097 18.132C19.6547 15.8657 20 13.4732 20 11C20 6.58172 16.4183 3 12 3C10.5429 3 9.17669 3.38958 8 4.07026M3 15.3641C3.64066 14.0454 4 12.5646 4 11C4 9.54285 4.38958 8.17669 5.07026 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronUpIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L11.2929 7.29289Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronDownIcon: FunctionComponent<IconProps> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z"
      fill="currentColor"
    />
  </svg>
);

export const RadarIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 23C18.5751 23 23.5 18.0751 23.5 12C23.5 5.92487 18.5751 1 12.5 1C6.42487 1 1.5 5.92487 1.5 12C1.5 18.0751 6.42487 23 12.5 23Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 17C15.2614 17 17.5 14.7614 17.5 12C17.5 9.23858 15.2614 7 12.5 7C9.73858 7 7.5 9.23858 7.5 12C7.5 14.7614 9.73858 17 12.5 17Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 11.9999L21.9 6.2999C20.9 4.6999 19.5 3.2999 17.8 2.3999L12.5 11.9999Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>
);

export const StopwatchIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3 8.59L19.21 7.69C19.3983 7.5017 19.5041 7.2463 19.5041 6.98C19.5041 6.7137 19.3983 6.4583 19.21 6.27C19.0217 6.0817 18.7663 5.97591 18.5 5.97591C18.2337 5.97591 17.9783 6.0817 17.79 6.27L16.89 7.18C15.4886 6.09585 13.7669 5.50764 11.995 5.50764C10.2232 5.50764 8.50147 6.09585 7.10003 7.18L6.19003 6.26C6.0004 6.0717 5.74373 5.96644 5.47649 5.96737C5.20925 5.96831 4.95333 6.07537 4.76503 6.265C4.57672 6.45463 4.47146 6.7113 4.4724 6.97854C4.47334 7.24578 4.5804 7.5017 4.77003 7.69L5.69003 8.6C4.59304 9.99755 3.99782 11.7233 4.00003 13.5C3.99676 14.7754 4.29849 16.0331 4.88005 17.1683C5.46161 18.3034 6.30614 19.283 7.34322 20.0254C8.38029 20.7679 9.57985 21.2516 10.8418 21.4362C12.1038 21.6208 13.3917 21.5011 14.598 21.0869C15.8043 20.6727 16.8941 19.9761 17.7764 19.0552C18.6588 18.1342 19.3082 17.0157 19.6705 15.7928C20.0328 14.5699 20.0974 13.2781 19.859 12.0251C19.6206 10.7722 19.0861 9.5944 18.3 8.59ZM12 19.5C10.8133 19.5 9.6533 19.1481 8.6666 18.4888C7.67991 17.8295 6.91087 16.8925 6.45675 15.7961C6.00262 14.6997 5.8838 13.4933 6.11531 12.3295C6.34683 11.1656 6.91827 10.0965 7.75739 9.25736C8.5965 8.41824 9.6656 7.8468 10.8295 7.61529C11.9934 7.38378 13.1998 7.5026 14.2961 7.95672C15.3925 8.41085 16.3296 9.17988 16.9888 10.1666C17.6481 11.1533 18 12.3133 18 13.5C18 15.0913 17.3679 16.6174 16.2427 17.7426C15.1174 18.8679 13.5913 19.5 12 19.5ZM10 4.5H14C14.2652 4.5 14.5196 4.39464 14.7071 4.20711C14.8947 4.01957 15 3.76522 15 3.5C15 3.23478 14.8947 2.98043 14.7071 2.79289C14.5196 2.60536 14.2652 2.5 14 2.5H10C9.73481 2.5 9.48046 2.60536 9.29292 2.79289C9.10538 2.98043 9.00003 3.23478 9.00003 3.5C9.00003 3.76522 9.10538 4.01957 9.29292 4.20711C9.48046 4.39464 9.73481 4.5 10 4.5ZM13 10.5C13 10.2348 12.8947 9.98043 12.7071 9.79289C12.5196 9.60536 12.2652 9.5 12 9.5C11.7348 9.5 11.4805 9.60536 11.2929 9.79289C11.1054 9.98043 11 10.2348 11 10.5V12.39C10.7736 12.5925 10.614 12.859 10.5423 13.1542C10.4707 13.4495 10.4904 13.7595 10.5988 14.0433C10.7072 14.3271 10.8992 14.5712 11.1494 14.7435C11.3996 14.9158 11.6962 15.008 12 15.008C12.3038 15.008 12.6004 14.9158 12.8507 14.7435C13.1009 14.5712 13.2929 14.3271 13.4013 14.0433C13.5097 13.7595 13.5294 13.4495 13.4577 13.1542C13.3861 12.859 13.2265 12.5925 13 12.39V10.5Z"
      fill="currentColor"
    />
  </svg>
);

export const LockClosedFilledIcon: FunctionComponent<IconProps> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 9V7C5 4.23858 7.23858 2 10 2C12.7614 2 15 4.23858 15 7V9C16.1046 9 17 9.89543 17 11V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V11C3 9.89543 3.89543 9 5 9ZM13 7V9H7V7C7 5.34315 8.34315 4 10 4C11.6569 4 13 5.34315 13 7Z"
      fill="currentColor"
    />
  </svg>
);

export const ClipboardCheckIcon: FunctionComponent<IconProps> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3H18C19.1046 3 20 3.89543 20 5V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V5C4 3.89543 4.89543 3 6 3H8ZM8 5H6V20H18V5H16V6C16 6.55228 15.5523 7 15 7H9C8.44772 7 8 6.55228 8 6V5ZM14 4H10V5H14V4ZM15.7071 10.7929C16.0976 11.1834 16.0976 11.8166 15.7071 12.2071L11.7071 16.2071C11.3166 16.5976 10.6834 16.5976 10.2929 16.2071L8.29289 14.2071C7.90237 13.8166 7.90237 13.1834 8.29289 12.7929C8.68342 12.4024 9.31658 12.4024 9.70711 12.7929L11 14.0858L14.2929 10.7929C14.6834 10.4024 15.3166 10.4024 15.7071 10.7929Z"
      fill="currentColor"
    />
  </svg>
);

export const RobotIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 15C8.80222 15 8.60888 15.0586 8.44443 15.1685C8.27998 15.2784 8.15181 15.4346 8.07612 15.6173C8.00043 15.8 7.98063 16.0011 8.01921 16.1951C8.0578 16.3891 8.15304 16.5673 8.29289 16.7071C8.43275 16.847 8.61093 16.9422 8.80491 16.9808C8.99889 17.0194 9.19996 16.9996 9.38268 16.9239C9.56541 16.8482 9.72159 16.72 9.83147 16.5556C9.94135 16.3911 10 16.1978 10 16C10 15.7348 9.89464 15.4804 9.70711 15.2929C9.51957 15.1054 9.26522 15 9 15ZM2 14C1.73478 14 1.48043 14.1054 1.29289 14.2929C1.10536 14.4804 1 14.7348 1 15V17C1 17.2652 1.10536 17.5196 1.29289 17.7071C1.48043 17.8946 1.73478 18 2 18C2.26522 18 2.51957 17.8946 2.70711 17.7071C2.89464 17.5196 3 17.2652 3 17V15C3 14.7348 2.89464 14.4804 2.70711 14.2929C2.51957 14.1054 2.26522 14 2 14ZM22 14C21.7348 14 21.4804 14.1054 21.2929 14.2929C21.1054 14.4804 21 14.7348 21 15V17C21 17.2652 21.1054 17.5196 21.2929 17.7071C21.4804 17.8946 21.7348 18 22 18C22.2652 18 22.5196 17.8946 22.7071 17.7071C22.8946 17.5196 23 17.2652 23 17V15C23 14.7348 22.8946 14.4804 22.7071 14.2929C22.5196 14.1054 22.2652 14 22 14ZM17 7H13V5.72C13.3023 5.54549 13.5536 5.29491 13.7291 4.99317C13.9045 4.69143 13.9979 4.34903 14 4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4C10.0021 4.34903 10.0955 4.69143 10.2709 4.99317C10.4464 5.29491 10.6977 5.54549 11 5.72V7H7C6.20435 7 5.44129 7.31607 4.87868 7.87868C4.31607 8.44129 4 9.20435 4 10V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V10C20 9.20435 19.6839 8.44129 19.1213 7.87868C18.5587 7.31607 17.7956 7 17 7ZM13.72 9L13.22 11H10.78L10.28 9H13.72ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V10C6 9.73478 6.10536 9.48043 6.29289 9.29289C6.48043 9.10536 6.73478 9 7 9H8.22L9 12.24C9.05475 12.4619 9.18385 12.6583 9.36579 12.7966C9.54774 12.9349 9.77157 13.0067 10 13H14C14.2284 13.0067 14.4523 12.9349 14.6342 12.7966C14.8162 12.6583 14.9452 12.4619 15 12.24L15.78 9H17C17.2652 9 17.5196 9.10536 17.7071 9.29289C17.8946 9.48043 18 9.73478 18 10V19ZM15 15C14.8022 15 14.6089 15.0586 14.4444 15.1685C14.28 15.2784 14.1518 15.4346 14.0761 15.6173C14.0004 15.8 13.9806 16.0011 14.0192 16.1951C14.0578 16.3891 14.153 16.5673 14.2929 16.7071C14.4327 16.847 14.6109 16.9422 14.8049 16.9808C14.9989 17.0194 15.2 16.9996 15.3827 16.9239C15.5654 16.8482 15.7216 16.72 15.8315 16.5556C15.9414 16.3911 16 16.1978 16 16C16 15.7348 15.8946 15.4804 15.7071 15.2929C15.5196 15.1054 15.2652 15 15 15Z"
      fill="currentColor"
    />
  </svg>
);

export const LightningBoltIcon: FunctionComponent<IconProps> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 3V10H20L11 21V14H4L13 3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UnlockIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12.9999C11.7348 12.9999 11.4804 13.1053 11.2929 13.2928C11.1054 13.4803 11 13.7347 11 13.9999V16.9999C11 17.2651 11.1054 17.5195 11.2929 17.707C11.4804 17.8946 11.7348 17.9999 12 17.9999C12.2652 17.9999 12.5196 17.8946 12.7071 17.707C12.8946 17.5195 13 17.2651 13 16.9999V13.9999C13 13.7347 12.8946 13.4803 12.7071 13.2928C12.5196 13.1053 12.2652 12.9999 12 12.9999ZM17 8.99992H9V6.99992C8.99854 6.40611 9.17334 5.82522 9.50226 5.33082C9.83118 4.83643 10.2994 4.45077 10.8477 4.22268C11.3959 3.99459 11.9996 3.93435 12.5821 4.04957C13.1646 4.16479 13.6999 4.45029 14.12 4.86992C14.4959 5.25399 14.7649 5.72975 14.9 6.24992C14.9328 6.3773 14.9904 6.49697 15.0695 6.60209C15.1486 6.70721 15.2476 6.79573 15.3609 6.86259C15.4742 6.92945 15.5995 6.97334 15.7298 6.99175C15.86 7.01017 15.9926 7.00275 16.12 6.96992C16.2474 6.93709 16.3671 6.87949 16.4722 6.80041C16.5773 6.72133 16.6658 6.62232 16.7327 6.50904C16.7995 6.39575 16.8434 6.2704 16.8618 6.14015C16.8802 6.0099 16.8728 5.8773 16.84 5.74992C16.6122 4.88472 16.1603 4.09486 15.53 3.45992C14.8302 2.76229 13.9393 2.28766 12.97 2.09596C12.0006 1.90427 10.9961 2.00411 10.0835 2.38288C9.17078 2.76164 8.3908 3.40235 7.84201 4.22409C7.29321 5.04584 7.00021 6.01177 7 6.99992V8.99992C6.20435 8.99992 5.44129 9.31599 4.87868 9.8786C4.31607 10.4412 4 11.2043 4 11.9999V18.9999C4 19.7956 4.31607 20.5586 4.87868 21.1212C5.44129 21.6838 6.20435 21.9999 7 21.9999H17C17.7956 21.9999 18.5587 21.6838 19.1213 21.1212C19.6839 20.5586 20 19.7956 20 18.9999V11.9999C20 11.2043 19.6839 10.4412 19.1213 9.8786C18.5587 9.31599 17.7956 8.99992 17 8.99992ZM18 18.9999C18 19.2651 17.8946 19.5195 17.7071 19.707C17.5196 19.8946 17.2652 19.9999 17 19.9999H7C6.73478 19.9999 6.48043 19.8946 6.29289 19.707C6.10536 19.5195 6 19.2651 6 18.9999V11.9999C6 11.7347 6.10536 11.4803 6.29289 11.2928C6.48043 11.1053 6.73478 10.9999 7 10.9999H17C17.2652 10.9999 17.5196 11.1053 17.7071 11.2928C17.8946 11.4803 18 11.7347 18 11.9999V18.9999Z"
      fill="currentColor"
    />
  </svg>
);

export const EditPencilIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2929 2.29289C16.6834 1.90237 17.3166 1.90237 17.7071 2.29289L21.7071 6.29289C22.0976 6.68342 22.0976 7.31658 21.7071 7.70711L8.70711 20.7071C8.51957 20.8946 8.26522 21 8 21H4C3.44772 21 3 20.5523 3 20V16C3 15.7348 3.10536 15.4804 3.29289 15.2929L13.2927 5.2931L16.2929 2.29289ZM14 7.41421L5 16.4142V19H7.58579L16.5858 10L14 7.41421ZM18 8.58579L19.5858 7L17 4.41421L15.4142 6L18 8.58579Z"
      fill="currentColor"
    />
  </svg>
);

export const UploadIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 8L12 3L7 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3V15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CodeIcon: FunctionComponent<IconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
    />
  </svg>
);
